module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_faktert.35ff1ccc.jpg";